import React from 'react';

import { useColorScheme } from '../hooks/useColorScheme';
import { colorScheme, ColorSchemeType } from '../modules/colorScheme';

export const ColorSchemeListener: React.FC = () => {
  const { setTheme } = useColorScheme();

  React.useEffect(() => {
    setTheme(colorScheme.getTheme());

    const changeTheme = (event: Event) => {
      const customEvent = event as CustomEvent<ColorSchemeType>;
      setTheme(customEvent.detail);
    };

    window.addEventListener('theme-change', changeTheme);

    return () => {
      window.removeEventListener('theme-change', changeTheme);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
